module.exports = __webpack_public_path__ + "static/predictivepoem 22-01-96179ee8c18108b998d62aaf0ba15ddc.jpg";